<template>
    <el-scrollbar class="education-wrapper" :native="false">
        <div class="steps-wrapper">
            <div class="step-item" :class="{ current: [1, 2, 3].includes(stepActive) }">
                <div class="step-line"></div>
                <div class="step-text">1</div>
                <div class="step-title">创建商品数据</div>
            </div>
            <div class="step-item" :class="{ current: [2, 3].includes(stepActive) }">
                <div class="step-line"></div>
                <div class="step-text">2</div>
                <div class="step-title">添加商品数据</div>
            </div>
            <div class="step-item" :class="{ current: [3].includes(stepActive) }">
                <div class="step-line"></div>
                <div class="step-text">3</div>
                <div class="step-title">创建成功</div>
            </div>
        </div>
        <div class="create-content" v-if="stepActive === 1">
            <el-form :model="stepOne" :rules="stepOneRules" ref="stepOne" label-width="120px">
                <el-form-item label="创建名称" prop="name">
                    <el-input
                        v-model="stepOne.name"
                        placeholder="4-30个字"
                        clearable
                        style="width: 500px"
                    ></el-input>
                </el-form-item>
                <el-form-item label="行业分类" prop="category_id">
                    <el-select
                        v-model="stepOne.category_id"
                        placeholder="请选择行业分类"
                        clearable
                        style="width: 500px"
                    >
                        <el-option
                            v-for="cateItem in categoryList"
                            :key="cateItem.id"
                            :label="cateItem.name"
                            :value="cateItem.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input
                        v-model="stepOne.remark"
                        placeholder="2-255个字"
                        style="width: 500px"
                        maxlength="255"
                        show-word-limit
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="create-content" v-if="stepActive === 2">
            <div class="stepTwo-head">
                <div class="left">
                    <el-button class="btn-red-line-all" size="small" @click="delChooseGoods"
                        >删除</el-button
                    >
                    <span class="text">关键词</span>
                    <el-select
                        v-model="hkd_id"
                        placeholder="请选择关键词"
                        @change="chooseHotKeyword"
                        clearable
                        style="width: 150px"
                    >
                        <el-option
                            v-for="hotItem in hotKeywordList"
                            :key="hotItem.id"
                            :label="hotItem.name"
                            :value="hotItem.id"
                        ></el-option>
                    </el-select>
                </div>
                <div class="right">
                    <span class="text">使用官方数据</span>
                    <el-select
                        v-model="templateId"
                        placeholder="自定义"
                        clearable
                        style="width: 150px"
                        @change="chooseOfficialData"
                        @clear="clearSingle"
                    >
                        <el-option
                            v-for="goodsItem in goodsList"
                            :key="goodsItem.id"
                            :label="goodsItem.name"
                            :value="goodsItem.id"
                        ></el-option>
                    </el-select>
                </div>
            </div>
            <el-table
                :data="stepOne.goods_data"
                border
                style="width: 100%; margin-top: 10px"
                size="medium"
                @selection-change="selectChange"
                :row-class-name="tableRowClassName"
                :header-cell-style="{
                    fontWeight: 'normal',
                    height: '60px',
                    color: '#13131B',
                    background: '#F2F3FA',
                }"
                :cell-style="{ fontSize: '14px', color: '#343441' }"
            >
                <el-table-column type="selection" align="center" width="55"></el-table-column>
                <el-table-column align="center" label="商品主图">
                    <template slot-scope="scope">
                        <el-upload
                            class="logo-uploader"
                            :action="uploadCover"
                            :headers="headersParams"
                            name="good_img"
                            :show-file-list="false"
                            :on-success="
                                (res, file) => {
                                    return handleCoverSuccess(res, file, scope.$index);
                                }
                            "
                            :before-upload="beforeCoverUpload"
                        >
                            <div class="goods-cover">
                                <img
                                    :src="
                                        scope.row.good_img
                                            ? scope.row.good_img
                                            : require('../../../assets/images/noimg.png')
                                    "
                                    alt=""
                                />
                            </div>
                            <!--                            <img v-if="imgSrc" :src="imgSrc" class="logo-cover">-->
                            <!--                            <i v-else class="el-icon-plus logo-uploader-icon"></i>-->
                        </el-upload>
                    </template>
                </el-table-column>
                <el-table-column label="商品标题" min-width="170px">
                    <template slot-scope="scope">
                        <el-input
                            v-model="scope.row.good_title"
                            placeholder="请输入商品名称"
                            style="width: 100%"
                        ></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="价格" width="112px">
                    <template slot-scope="scope">
                        <el-input-number
                            v-model="scope.row.good_price"
                            :min="0.01"
                            :precision="2"
                            :controls="false"
                            style="width: 100%"
                            placeholder="价格"
                        ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="销量" width="112px">
                    <template slot-scope="scope">
                        <el-input-number
                            v-model="scope.row.good_sale_num"
                            :min="0"
                            :precision="0"
                            :controls="false"
                            style="width: 100%"
                            placeholder="销量"
                        ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="转化率（%）" width="112px">
                    <template slot-scope="scope">
                        <el-input-number
                            v-model="scope.row.tran_rate"
                            :min="0.01"
                            :max="100"
                            :precision="2"
                            :controls="false"
                            style="width: 100%"
                            placeholder="转化率"
                        ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="点击率（%）" width="112px">
                    <template slot-scope="scope">
                        <el-input-number
                            v-model="scope.row.click_rate"
                            :min="0.01"
                            :max="100"
                            :precision="2"
                            :controls="false"
                            style="width: 100%"
                            placeholder="点击率"
                        ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="质量分" width="112px">
                    <template slot-scope="scope">
                        <el-input-number
                            v-model="scope.row.quality_score"
                            :min="1"
                            :max="10"
                            :precision="0"
                            :controls="false"
                            style="width: 100%"
                            placeholder="质量分"
                        ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="质量分波动范围" min-width="170px">
                    <template slot-scope="scope">
                        <div class="wavy-range-box flex align-center">
                            <el-input-number
                                v-model="scope.row.low_wave"
                                :min="-99"
                                :max="899"
                                :precision="0"
                                :controls="false"
                                style="width: 90px"
                                placeholder="低值"
                            ></el-input-number>
                            <span class="symbol-style">%</span>
                            <span class="wavy-line">~</span>
                            <el-input-number
                                v-model="scope.row.high_wave"
                                :min="-98"
                                :max="900"
                                :precision="0"
                                :controls="false"
                                style="width: 90px"
                                placeholder="高值"
                            ></el-input-number>
                            <span class="symbol-style">%</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-button
                size="small"
                class="btn-blue-line-all"
                style="margin-top: 10px"
                @click="addBtn"
                >添加新商品信息</el-button
            >
        </div>
        <div class="create-content" v-if="stepActive === 3">
            <div class="success-content">
                <i class="iconfont">&#xe730;</i>
                <p class="text">创建成功！</p>
            </div>
        </div>
        <div class="bottom-btn">
            <el-button
                @click="prevBtn(stepActive)"
                class="btn-blue-line-all"
                v-if="stepActive === 1 || stepActive === 2"
                >上一步</el-button
            >
            <el-button
                @click="prevBtn(stepActive)"
                class="btn-blue-line-all"
                v-if="stepActive === 3"
                >返回</el-button
            >
            <el-button
                class="btn-blue"
                @click="nextBtn(stepActive, 'stepOne')"
                v-if="stepActive === 1"
                >下一步</el-button
            >
            <el-button class="btn-blue" @click="nextBtn(stepActive)" v-if="stepActive === 2"
                >下一步</el-button
            >
        </div>
    </el-scrollbar>
</template>

<script>
export default {
    data() {
        return {
            goodInfoId: Number(this.$route.query.id) || '',
            stepActive: 1,
            stepOne: {
                name: '',
                category_id: '',
                remark: '',
                goods_data: [], // 添加的商品列表
            },
            stepOneRules: {
                name: [
                    { required: true, message: '请输入商品信息名称', trigger: 'blur' },
                    { min: 4, max: 30, message: '长度在 4 到 30 个字', trigger: 'blur' },
                ],
                category_id: [{ required: true, message: '请选择行业分类', trigger: 'change' }],
            },
            categoryList: [],
            hkd_id: '', // 关键词id
            hotKeywordList: [],
            templateId: null,
            goodsList: [], // 官方数据列表
            // S 上传图片需要
            uploadCover: this.$api.goodInfoUpload,
            headersParams: {
                Authorization: localStorage.getItem('token'),
            },
            goodImgList: [],
            // imgSrc: null,
            // E 上传图片需要
            chooseGoodsList: [],
        };
    },
    mounted() {
        this.getCategoryList();
        this.getHotKeywordsList();
        this.getGoodsList();
        this.getOneGoodsInfo();
    },
    methods: {
        // 获取单条商品模板信息
        getOneGoodsInfo() {
            if (this.goodInfoId) {
                this.$http.axiosGetBy(
                    this.$api.goodInfoOne,
                    { id: this.goodInfoId },
                    res => {
                        if (res.code === 200) {
                            this.stepOne = res.data;
                            this.hkd_id = res.data.goods_data[0].hkd_id;
                        } else {
                            this.$message.warning(res.msg);
                        }
                    },
                    err => {
                        console.log(err);
                    }
                );
            }
        },
        // 选择官方数据
        chooseOfficialData(val) {
            if (val) {
                this.$http.axiosGetBy(
                    this.$api.goodInfoUseOne,
                    { id: val },
                    res => {
                        if (res.code === 200) {
                            this.stepOne.goods_data = res.data;
                            this.hkd_id = res.data[0].hkd_id;
                        } else {
                            this.$message.warning(res.msg);
                        }
                    },
                    err => {
                        console.log(err);
                    }
                );
            }
        },
        // 清除选择官方数据
        clearSingle() {
            this.stepOne.goods_data = [];
            this.hkd_id = '';
        },
        // 获取行业分类列表
        getCategoryList() {
            this.$http.axiosGet(
                this.$api.categoryList,
                res => {
                    if (res.code === 200) {
                        this.categoryList = res.data;
                    } else {
                        this.$message.warning(res.msg);
                    }
                },
                err => {
                    console.log(err);
                }
            );
        },
        // 获取热门关键词列表
        getHotKeywordsList() {
            this.$http.axiosGet(
                this.$api.hotKeywordList,
                res => {
                    if (res.code === 200) {
                        this.hotKeywordList = res.data;
                    } else {
                        this.$message.warning(res.msg);
                    }
                },
                err => {
                    console.log(err);
                }
            );
        },
        // 筛选关键词
        chooseHotKeyword(val) {
            this.stepOne.goods_data = this.stepOne.goods_data.map(item => {
                item.hkd_id = val;
                return item;
            });
        },
        // 获取商品信息列表
        getGoodsList() {
            this.$http.axiosGet(
                this.$api.goodInfoList,
                res => {
                    if (res.code === 200) {
                        this.goodsList = res.data;
                    } else {
                        this.$message.warning(res.msg);
                    }
                },
                err => {
                    console.log(err);
                }
            );
        },
        // 表格多选
        selectChange(selection) {
            this.chooseGoodsList = selection;
        },
        // 行class的回调函数，把index放到商品表格数据里面
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        // 上一步按钮
        prevBtn(index) {
            if (index === 1) {
                this.$router.go(-1);
            } else if (index === 2) {
                this.stepActive = 1;
            } else if (index === 3) {
                this.$router.push('/admin/operatedata/goodsinfo');
            }
        },
        // 下一步按钮
        nextBtn(index, formName) {
            if (this.stepOne.category_id == 0 || this.stepOne.category_id == '') {
                this.stepOne.category_id = '';
                this.$message.error('请重新选择行业分类');
                return;
            }
            // 第一步的下一步
            if (index === 1) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.stepActive = 2;
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
                // 第二步的下一步
            } else if (index === 2) {
                if (this.hkd_id === '') {
                    this.$message.warning('请选择关键词');
                    return;
                }
                if (this.stepOne.goods_data.length === 0) {
                    this.$message.warning('请添加商品信息');
                    return;
                }
                for (let i = 0; i < this.stepOne.goods_data.length; i++) {
                    let itemTmp = this.stepOne.goods_data[i];
                    // 波动范围值前者应小于后者
                    if (itemTmp.low_wave >= itemTmp.high_wave) {
                        return this.$message.warning('波动范围低值不能大于等于高值');
                    }
                    // 判断输入框是否为空
                    if (itemTmp.good_img === null) {
                        return this.$message.warning('请选择商品图片');
                    } else if (!itemTmp.good_title) {
                        return this.$message.warning('请输入商品标题');
                    } else if (itemTmp.good_price === void 0) {
                        return this.$message.warning('请输入商品价格');
                    } else if (itemTmp.good_sale_num === void 0) {
                        return this.$message.warning('请输入销量');
                    } else if (itemTmp.tran_rate === void 0) {
                        return this.$message.warning('请输入转化率');
                    } else if (itemTmp.click_rate === void 0) {
                        return this.$message.warning('请输入点击率');
                    } else if (itemTmp.quality_score === void 0) {
                        return this.$message.warning('请输入质量分');
                    } else if (itemTmp.low_wave === void 0) {
                        return this.$message.warning('请输入波动范围低值');
                    } else if (itemTmp.high_wave === void 0) {
                        return this.$message.warning('请输入波动范围高值');
                    }
                }

                // 判断商品标题是否重复
                let result = false;
                outer: for (let i = 0; i < this.stepOne.goods_data.length - 1; i++) {
                    for (let j = i + 1; j < this.stepOne.goods_data.length; j++) {
                        if (
                            this.stepOne.goods_data[i].good_title ===
                            this.stepOne.goods_data[j].good_title
                        ) {
                            result = true;
                            break outer;
                        }
                    }
                }
                if (result === true) {
                    this.$message.warning('商品名称重复了，请修改');
                    return;
                }

                let formData = new FormData();
                formData.append('name', this.stepOne.name);
                formData.append('category_id', this.stepOne.category_id);
                formData.append('remark', this.stepOne.remark);
                formData.append('goods', JSON.stringify(this.stepOne.goods_data));
                if (this.goodInfoId) {
                    formData.append('id', this.goodInfoId);
                }
                this.$http.axiosPost(
                    this.$api.goodInfoSave,
                    formData,
                    res => {
                        if (res.code === 200) {
                            this.$message.success(res.msg);
                            this.stepActive = 3;
                        } else {
                            this.$message.warning(res.msg);
                        }
                    },
                    err => {
                        console.log(err);
                    }
                );
            }
        },
        // 添加新商品信息
        addBtn() {
            let goodTmp = {
                // hkd_id: '',
                good_img: null,
                good_title: '',
                good_price: void 0, // undefined
                good_sale_num: void 0,
                tran_rate: void 0,
                click_rate: void 0,
                quality_score: void 0,
                low_wave: void 0,
                high_wave: void 0,
            };
            if (this.hkd_id) {
                goodTmp.hkd_id = this.hkd_id;
            } else {
                goodTmp.hkd_id = '';
            }
            let imgSrcTmp = {
                imgSrc: null,
            };
            this.stepOne.goods_data.push(goodTmp);
            this.goodImgList.push(imgSrcTmp);
        },
        // start 上传图片
        beforeCoverUpload(file) {
            const isImg =
                file.name.toLowerCase().endsWith('.jpg') ||
                file.name.toLowerCase().endsWith('.jpeg') ||
                file.name.toLowerCase().endsWith('.png');
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isImg) {
                this.$message.error('上传图片只能是 jpg 或 jpeg 或 png 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return isImg && isLt2M;
        },
        handleCoverSuccess(res, file, index) {
            if (res.code === 200) {
                // this.goodImgList[index].imgSrc = res.data.src // 有域名, 展示  ceshi
                this.stepOne.goods_data[index].good_img = res.data.url; // 无域名，表单提交
                this.$message.success('图片上传成功');
            } else {
                this.$message.error('图片上传失败，请稍后再试~');
            }
        },
        // end 上传图片
        // 删除商品
        delChooseGoods() {
            if (this.stepOne.goods_data.length === 0) {
                return this.$message.warning('请先添加商品信息');
            } else if (this.chooseGoodsList.length === 0) {
                return this.$message.warning('请选择要删除的商品信息');
            } else {
                this.$confirm('是否删除所选择的商品吗，删除完将无法恢复', '提示消息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'btn-red',
                    type: 'warning',
                })
                    .then(() => {
                        this.stepOne.goods_data = this.stepOne.goods_data.filter(item => {
                            let arrTmp = this.chooseGoodsList.map(selectItem => selectItem.index);
                            return arrTmp.includes(item.index) === false;
                        });
                        this.$message.success('删除成功');
                    })
                    .catch(() => {
                        this.$message.info('已取消删除');
                    });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.education-wrapper {
    height: 100%;
    ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
        .el-scrollbar__view {
            padding: 30px;
        }
    }
}
.steps-wrapper {
    margin-top: 70px;
}
.create-content {
    margin: 60px 0;
}
.success-content {
    margin-top: 155px;
    text-align: center;
    .iconfont {
        color: #1fd18c;
        font-size: 52px;
    }
    .text {
        font-size: 24px;
        margin: 20px 0 0;
        font-weight: bold;
    }
}
.bottom-btn {
    text-align: center;
}
.stepTwo-head {
    display: flex;
    justify-content: space-between;
    .text {
        margin: 0 10px 0 20px;
    }
}
.goods-cover {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 1px solid #eee;
    background: #fafafa;
    img {
        max-width: 100%;
        max-height: 100%;
    }
}
.symbol-style {
    margin-left: 6px;
}
.wavy-line {
    line-height: 40px;
    margin: 0 7px 0 6px;
}
::v-deep .el-input-number {
    .el-input__inner {
        text-align: left;
    }
}
</style>
